import script from "./TagVue.vue?vue&type=script&setup=true&lang=js"
export * from "./TagVue.vue?vue&type=script&setup=true&lang=js"

import "./TagVue.vue?vue&type=style&index=0&id=d7015c38&lang=scss&scoped=true"

import exportComponent from "../../fin_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d7015c38"]])

export default __exports__